import { render, staticRenderFns } from "./dept_tree_table.vue?vue&type=template&id=65ee913b&scoped=true&"
import script from "./dept_tree_table.vue?vue&type=script&lang=js&"
export * from "./dept_tree_table.vue?vue&type=script&lang=js&"
import style0 from "./dept_tree_table.vue?vue&type=style&index=0&id=65ee913b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ee913b",
  null
  
)

export default component.exports